import React, { useContext, useEffect, useState } from "react";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES } from "../../../utils/consts";
import { useHistory } from "react-router-dom";
import TransferList from "../admin/TransferList";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import TransferFilter from "../../elements/transfer/admin/TransferFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { AppContext } from "../../../App";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTransferWrapper } from "./styledTransfer";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const TransferContainer = () => {
  const { t } = useTranslation("transferPage");
  const history = useHistory();
  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [transfers, setTransfers] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "id": checkFilterItem(history, "id", null),
    "note": checkFilterItem(history, "note", null),
    "receiver.email": checkFilterItem(history, "receiver.email", null),
    "receiver.nickname": checkFilterItem(history, "receiver.nickname", null),
    "sender.email": checkFilterItem(history, "sender.email", null),
    "sender.nickname": checkFilterItem(history, "sender.nickname", null),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null),
    "status": checkFilterItem(history, "status", null),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "updatedAt[gte]": checkFilterItem(history, "updatedAt[gte]", null, true),
    "updatedAt[lte]": checkFilterItem(history, "updatedAt[lte]", null, true)
  });

  const fetchTransfersList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get(
      `/api/get-transfer-native${filterUrl}`,
      userAuthenticationConfig()).
      then(response => {
        if (response.status === HTTP_STATUSES.HTTP_OK) {
          setTransfers(response.data["hydra:member"]);
          setTotalPageCount(response.data["hydra:totalPageCount"]);
        }
      }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
      });
  };

  useEffect(() => {
    fetchTransfersList();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledTransferWrapper>
          <div className="transfer-head">
            <TransferFilter
              filterData={filterData}
              setFilterData={setFilterData}
              userId={user.userId}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <TransferList
            transfers={transfers}
            notification={notification}
            setNotification={setNotification}
          />
          {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
        </StyledTransferWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default TransferContainer;